import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Show } from '$components/submissions';
import { getSubmission, createSubmissionAppeal } from '../../api';
import Cookies from 'js-cookie';
import { Translate } from '$common';
import { showNotification } from '$actions/root';

const agent = (Cookies.get('agent') && JSON.parse(Cookies.get('agent'))) || {};

@connect(null, { showNotification })
export default class ShowRoute extends Component {
  state = {
    submission: null
  };

  async loadData() {
    const { submissionId, id } = this.props.params;
    const { data: submission } = await getSubmission(submissionId);
    this.setState({ submission });
  }

  async sendAppeal(values) {
    const { submission } = this.state;
    try {
      await createSubmissionAppeal(submission.id, values);
      this.props.showNotification(Translate.get('appeal_sent_success'), 'success');
    } catch (e) {
      this.props.showNotification(Translate.get('appeal_sent_error'), 'error');
      console.error(e);
    }
  }

  componentWillMount() {
    this.loadData();
  }

  render() {
    const { submission } = this.state;
    const { project } = this.props;

    return project && submission ? (
      <Show
        submission={submission}
        project={project}
        agent={agent}
        sendAppeal={::this.sendAppeal}
      />
    ) : null
  }
}



// WEBPACK FOOTER //
// ./src/routes/submissions/show.js